import React from 'react';
import { getGreetingMessageExample } from 'api/common';
import { EGreetingMessageTony } from 'types/ai';

let globalData: string = '';

const useGreetingMessageExample = (params?: { messageTone: EGreetingMessageTony | null | undefined, customPrompt: string }): [string, boolean, (id?: number) => void] => {
    const [loading, setLoading] = React.useState(false);
    const [items, setItems] = React.useState<string>(globalData);
    const fetchData = async () => {
        try {
            setLoading(true);
            const result = await getGreetingMessageExample(params?.messageTone!, params?.customPrompt!);
            if (!result.error) {
                const data: string = result?.data?.data || '';
                globalData = data;
                setItems(globalData);
            }
            setLoading(false);
        } catch (e) {
            console.error(e);
            setLoading(false);
        }
    };
    React.useEffect(() => {
        if (!loading && params && params.customPrompt) {
            fetchData();
        }
    }, [params]);

    return [items, loading, fetchData];
};

export default useGreetingMessageExample;
